import { Outlet } from "react-router-dom";
import Footer from "../components/Footer";
import OurNav from "../components/Navbar";

const Layout = () => {
  return (
    <>

      <OurNav />
      <Outlet />
      <Footer></Footer>
    </>
  )
};

export default Layout;